function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentCurrencyRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.09a9.91 9.91 0 110 19.822 9.91 9.91 0 010-19.822zm3.027 2.603A7.91 7.91 0 1020 27.91 7.922 7.922 0 0027.91 20a7.91 7.91 0 00-4.883-7.307zM20.12 19.56l2.17-5.1H25l-2.63 5.1h1.74v1.85h-2.85v1h2.85v1.89h-2.85v2.17h-2.44V24.3H16v-1.85h2.87v-1H16v-1.89h1.7l-2.63-5.1h2.86l2.19 5.1zM8.473 2.327A9 9 0 0119.48 8.11c-.672.028-1.341.112-2 .25A7 7 0 004 11a7 7 0 004.36 6.52 12.373 12.373 0 00-.25 2 9 9 0 01.363-17.193zM8.26 12.45a6.82 6.82 0 001.8 1c-.36.546-.675 1.122-.94 1.72A9.003 9.003 0 017 13.92l1.26-1.47zM12 6.48a6.502 6.502 0 012.75 1.38l-1.27 1.5c-1.11-.91-2.22-1.24-3-.91a1 1 0 00-.67.62c0 .51.42.74 2 1.16.32.08.66.18 1 .29-.601.463-1.16.978-1.67 1.54-1.36-.37-3.28-1-3.28-3a2.741 2.741 0 011.73-2.34c.133-.062.27-.115.41-.16V5h2v1.48z",
    fill: props.color
  }));
}

export default SvgIconPaymentCurrencyRexOutline;